import { z } from 'zod';

/** Workflow states:
 *  - draft = user created receipt and is still editing it, uploading files, etc.
 *  - approval = user is done and submitted it to their manager to approve
 *  - payment = manager has approved, fincance needs to process
 *  - completed = all done
 */
export const WorkflowState = z.enum([
    'draft',
    'clearing',
    'approval',
    'closing',
    'payment',
    'completed',
    'canceled',
]);
export type WorkflowState = z.infer<typeof WorkflowState>;
export const WorkflowStateValues = WorkflowState.options;
